import axios from 'axios'

import appConfig from './appConfig'

export default class CsPluginBffServices {
  static getOauthSalesforceToken(code) {
    return new Promise(resolve => {
      const url = `${appConfig.csPluginBffApiUrl}/cs-authenticator/stone/oauth/token`

      axios
        .post(url, { code, redirectUri: `${window.location.origin}/` })
        .then(res => {
          resolve({ accessToken: res.data.access_token })
        })
        .catch(err => {
          resolve({ err })
        })
    })
  }

  static validateSalesforceSId(sessionId) {
    return new Promise(resolve => {
      const url = `${appConfig.csPluginBffApiUrl}/cs-authenticator/stone/authenticate`
      const headers = { Authorization: `Bearer ${sessionId}` }

      axios
        .get(url, { headers })
        .then(res => {
          resolve({ valid: true, ...res.data })
        })
        .catch(() => {
          resolve({ valid: false })
        })
    })
  }
}
